import Head from "next/head";
import Link from "next/link";
import Image from "next/image";
import { getHomePageDataBySlug } from "../../utils/GhostAPI";
import { redirectTo500 } from "../../utils/utility";
import { ENDPOINTS } from "../../utils/api-endpoints";
import ImageGallery from "react-image-gallery";

export async function getStaticProps(context) {
  let pageData = await getHomePageDataBySlug(ENDPOINTS.CAMPUS);

  if (!pageData) {
    return redirectTo500();
  }

  return {
    props: {
      pageData: pageData,
    },
    revalidate: 3600,
  };
}

const images = [
  {
    original: "/images/campus_gallary/slide-2.jpg",
    thumbnail: "/images/campus_gallary/slide-2.jpg",
  },
  {
    original: "/images/campus_gallary/slide-4.jpg",
    thumbnail: "/images/campus_gallary/slide-4.jpg",
  },
  {
    original: "/images/campus_gallary/slide-5.jpg",
    thumbnail: "/images/campus_gallary/slide-5.jpg",
  },
  {
    original: "/images/campus_gallary/slide-6.jpg",
    thumbnail: "/images/campus_gallary/slide-6.jpg",
  },
  {
    original: "/images/campus_gallary/slide-7.jpg",
    thumbnail: "/images/campus_gallary/slide-7.jpg",
  },
  {
    original: "/images/campus_gallary/slide-8.jpg",
    thumbnail: "/images/campus_gallary/slide-8.jpg",
  },
  {
    original: "/images/campus_gallary/slide-9.jpg",
    thumbnail: "/images/campus_gallary/slide-9.jpg",
  },
  {
    original: "/images/campus_gallary/slide-10.jpg",
    thumbnail: "/images/campus_gallary/slide-10.jpg",
  },
  {
    original: "/images/campus_gallary/slide-11.jpg",
    thumbnail: "/images/campus_gallary/slide-11.jpg",
  },
  {
    original: "/images/campus_gallary/slide-12.jpg",
    thumbnail: "/images/campus_gallary/slide-12.jpg",
  },
  {
    original: "/images/campus_gallary/slide-14.jpg",
    thumbnail: "/images/campus_gallary/slide-14.jpg",
  },
  {
    original: "/images/campus_gallary/slide-16.jpg",
    thumbnail: "/images/campus_gallary/slide-16.jpg",
  },
  {
    original: "/images/campus_gallary/slide-17.jpg",
    thumbnail: "/images/campus_gallary/slide-17.jpg",
  },
  {
    original: "/images/campus_gallary/slide-18.jpg",
    thumbnail: "/images/campus_gallary/slide-18.jpg",
  },
  {
    original: "/images/campus_gallary/slide-19.jpg",
    thumbnail: "/images/campus_gallary/slide-19.jpg",
  },
  {
    original: "/images/campus_gallary/slide-20.jpg",
    thumbnail: "/images/campus_gallary/slide-20.jpg",
  },
];

const Campus = props => {
  return (
    <>
      <Head>
        <title>Campus | Top Software Company in Bangladesh</title>
        <meta
          name="description"
          content="Our 18,000 square feet office space is designed to stimulate productivity and inspire innovation. Our server room is equipped with 70+ servers and necessary routers and switches."
        />
      </Head>
      <div className="bg-white w-full py-12 md:py-16">
        <div className="grid mid-home-column items-center">
          <h2 className="text-black font-headline items-center break-words text-center font-normal text-4xl md:text-6xl mb-1">
            Life at DSi
          </h2>
        </div>
      </div>

      <div className="mid-home-column pb-12 md:pb-28">
        <div className="flex mx-5 ">
          <div className="flex mx-auto">
            <video loop autoPlay controls>
              <source
                src="/video/dsi-campus-short-video.mp4"
                type="video/mp4"
              />
            </video>
          </div>
        </div>
      </div>
      <div className="grid mid-home-column pb-12 md:pb-28">
        <div className="mx-16">
          <div className="pb-9 md:pb-20 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Facilities
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-2xl leading-8 text-gray-600">
              Live your best office life
            </p>
          </div>

          <div className="grid">
            <div className="grid grid-cols-1 md:grid-cols-3 md:grid-rows-3 gap-y-6 md:gap-y-20 md:gap-x-12 lg:gap-x-28">
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Festival_bonus.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="pt-4 pb-2 text-xl font-extrabold text-center font-body">
                  Festival Bonus
                </p>
                <p className="text-base font-medium text-center text-gray-600 font-body">
                  Celebrate and share twice a year
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Marriage_bonus.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="pt-4 pb-2 text-xl font-extrabold text-center font-body">
                  Marriage Bonus
                </p>
                <p className="text-base font-medium text-center text-gray-600 font-body">
                  Start your new chapter, worry a little less
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Buffet_lunch.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Buffet Lunch
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Cooked in our own kitchen, fresh and healthy
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Yearly_increment.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Yearly Increment
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Get rewarded for your hard work every year
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Flexible_working_hour.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Flexible Working Hour
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Yes, we have working hours, just not carved in stone
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Indoor_games.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Indoor Games
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Racket or gamepad - choose one, break a sweat
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Annual_retreat.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Annual Retreat
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Pack your bags, bring your family, the little ones enjoy the
                  most
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Paid_maternity_leave.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-xl text-center font-extrabold pt-4 pb-2">
                  Paid Maternity Leave
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  We got your back on your most vulnerable days
                </p>
              </div>
              <div className="flex flex-col items-center">
                <div className="">
                  <Image
                    alt="Hero image for news section"
                    src="/images/campus_gallary/Cosy_environment.svg"
                    width="60"
                    height="60"
                    layout="intrinsic"
                    loading="lazy"
                  />
                </div>
                <p className="font-body text-center text-xl font-extrabold pt-4 pb-2">
                  Cosy Environment
                </p>
                <p className="font-body text-center text-base text-gray-600 font-medium">
                  Rock your t-shirt, crack a joke, take a nap, it's your place
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mid-home-column pb-12 md:pb-28 mx-auto ">
        <div className="mx-5">
          <div className="pb-9 md:pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Tour Our Campus
            </h2>
            <p className="flex font-headline items-center text-base md:text-2xl leading-8 text-gray-600">
              Explore DSi life
            </p>
          </div>

          {/* slider here */}
          <ImageGallery items={images} />
        </div>
      </div>

      <div></div>
      <div className="bg-white w-full pb-12 md:pb-28">
        <div className="grid mid-home-column">
          <div className="pb-9 md:pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline break-words text-center font-extrabold text-3xl md:text-4xl mb-4">
              Check Out New Openings
            </h2>
            <p className="flex font-headline text-center text-base md:text-2xl leading-8 text-gray-600">
              DSi is growing and we need experts in different fields. See our
              open positions and apply with your updated CV. We are very
              responsive in the hiring process.
            </p>
            <Link href="https://app.hrythmic.com/recruit/openings/company/dsinnovators/">
              <a target="_blank">
                <p className="border border-black text-center inline-block bg-yellow-btn hover:bg-black hover:text-white font-button px-8 py-2 text-xs font-semibold mt-12 mx-auto">
                  CHECK NOW
                </p>
              </a>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Campus;
